interface StatusBadgeProps {
  status: string;
  label?: string;
}

const STATUS_STYLES: Record<string, string> = {
  planning: 'bg-purple-100 text-purple-800',
  in_progress: 'bg-blue-100 text-blue-800',
  on_hold: 'bg-amber-100 text-amber-800',
  completed: 'bg-emerald-100 text-emerald-800',
  cancelled: 'bg-red-100 text-red-800',
  pending: 'bg-amber-100 text-amber-800',
  approved: 'bg-emerald-100 text-emerald-800',
  rejected: 'bg-red-100 text-red-800',
  draft: 'bg-slate-100 text-slate-700',
  active: 'bg-emerald-100 text-emerald-800',
  inactive: 'bg-slate-100 text-slate-500',
};

const STATUS_LABELS: Record<string, string> = {
  planning: 'Planificación',
  in_progress: 'En progreso',
  on_hold: 'En pausa',
  completed: 'Completado',
  cancelled: 'Cancelado',
  pending: 'Pendiente',
  approved: 'Aprobado',
  rejected: 'Rechazado',
  draft: 'Borrador',
  active: 'Activo',
  inactive: 'Inactivo',
};

export function StatusBadge({ status, label }: StatusBadgeProps) {
  const style = STATUS_STYLES[status] ?? 'bg-slate-100 text-slate-700';
  const text = label ?? STATUS_LABELS[status] ?? status;
  return (
    <span className={`inline-block text-xs px-2.5 py-1 rounded-full font-semibold ${style}`}>
      {text}
    </span>
  );
}